import type { ProcessBlueprintLog } from '../../../../types/processBlueprintLog';

interface GovernanceLogTabProps {
  logs: ProcessBlueprintLog[];
}

export function GovernanceLogTab({ logs }: GovernanceLogTabProps) {
  if (!logs?.length) return <div className="text-sm text-gray-500 dark:text-slate-400">Sem registros de governança.</div>;

  return (
    <div className="space-y-3">
      {logs.map((log) => (
        <div key={log.id} className="p-3 border rounded-md border-gray-200 dark:border-slate-700">
          <div className="flex items-center justify-between text-sm">
            <span className="font-semibold">{log.action}</span>
            <span className="text-gray-500 dark:text-slate-400">{new Date(log.created_at).toLocaleString()}</span>
          </div>
          <div className="text-xs text-gray-500 dark:text-slate-400">{log.actor}</div>
          <div className="text-sm">{log.details || 'Sem detalhes'}</div>
        </div>
      ))}
    </div>
  );
}
